import type React from 'react'

/** Stroke from the Figma asset; no ui-kit theme equivalent. */
const AI_STROKE = '#373743'

interface AiIconProps {
  size?: number
  color?: string
}

/**
 * The design system's AI mark: four stroked petals pinwheeling around a
 * centre. Used to badge AI-generated content, currently the suggested-needs
 * panel on the care plan review.
 */
const AiIcon: React.FC<AiIconProps> = ({ size = 24, color = AI_STROKE }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5267 12.7341C15.0758 13.7032 16.4302 14.1593 17.4148 13.7021C18.6361 13.1351 19.3109 12.0661 19.9925 10.945C20.6742 9.82381 20.1003 9.38269 18.9373 9.47749C18.4604 9.51637 16.6546 9.60599 15.3768 10.3499C13.9638 11.1727 14.2386 12.2267 14.5267 12.7341Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M9.45334 11.109C9.91611 12.1223 9.49104 13.4866 8.54329 14.0159C7.36761 14.6725 6.10604 14.592 4.79822 14.4864C3.49039 14.3808 3.46972 13.6573 4.22868 12.771C4.5399 12.4075 5.67171 10.9976 7.02373 10.3991C8.5189 9.73725 9.21136 10.5781 9.45334 11.109Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M11.5368 14.236C10.5052 14.6563 9.87916 15.941 10.2062 16.9761C10.6119 18.2601 11.5854 19.0665 12.6098 19.8863C13.6342 20.7061 14.1454 20.1936 14.2006 19.0281C14.2232 18.5501 14.366 16.7477 13.7921 15.3851C13.1575 13.8781 12.0769 14.0155 11.5368 14.236Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M12.9941 9.5195C11.9724 9.96331 10.6163 9.51288 10.1047 8.55543C9.47018 7.36771 9.57416 6.10787 9.70411 4.80223C9.83405 3.4966 10.5578 3.48942 11.4298 4.26478C11.7874 4.58272 13.1761 5.74061 13.7492 7.10355C14.3831 8.6108 13.5295 9.28746 12.9941 9.5195Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
)

export default AiIcon
